'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _components = require('../../../../components');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Links = require('./Links.scss');

var _Links2 = _interopRequireDefault(_Links);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var year = new Date().getFullYear();

var Links = function (_PureComponent) {
    (0, _inherits3.default)(Links, _PureComponent);

    function Links() {
        (0, _classCallCheck3.default)(this, Links);
        return (0, _possibleConstructorReturn3.default)(this, (Links.__proto__ || (0, _getPrototypeOf2.default)(Links)).apply(this, arguments));
    }

    (0, _createClass3.default)(Links, [{
        key: 'render',
        value: function render() {
            var name = this.props.name;


            return (0, _jsx3.default)('div', {
                className: _Links2.default.links
            }, void 0, (0, _jsx3.default)('div', {
                className: _Links2.default.linksInner
            }, void 0, (0, _jsx3.default)('div', {
                className: _Links2.default.linksUpper
            }, void 0, (0, _jsx3.default)('span', {
                className: _Links2.default.name
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'powered_by',
                values: {
                    name: name,
                    onlineAuctions: (0, _jsx3.default)(_components.Link, {
                        className: _Links2.default.blackLink,
                        to: 'https://www.liveauctioneers.com'
                    }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'onlineAuctions'
                    }))
                }
            })), (0, _jsx3.default)(_components.Link, {
                to: 'https://www.liveauctioneers.com/'
            }, void 0, (0, _jsx3.default)('img', {
                src: 'https://p1.liveauctioneers.com/dist/images/logo.svg',
                alt: 'liveauctioneers'
            }))), (0, _jsx3.default)('div', {
                className: _Links2.default.linksLower
            }, void 0, (0, _jsx3.default)('span', {
                className: _Links2.default.copyright
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'copyright_whitelabel',
                values: {
                    privacy: (0, _jsx3.default)(_components.Link, {
                        route: true,
                        to: '/privacy'
                    }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'privacy'
                    })),
                    terms: (0, _jsx3.default)(_components.Link, {
                        route: true,
                        to: '/termsandconditions'
                    }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'terms'
                    })),
                    year: year
                }
            })))));
        }
    }]);
    return Links;
}(_react.PureComponent);

exports.default = Links;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/WhiteLabelFooter/Links/Links.js
// module id = n0xG
// module chunks = 57